export const SALES_PUBLIC_CONSTANTS = Object.freeze({
    PROJECTS_LIST: 'SALES_PUBLIC__PROJECTS_LIST',
    ORDER_CREATE: 'SALES_PUBLIC__ORDER_CREATE',
});

const C = SALES_PUBLIC_CONSTANTS;
export const SALES_PUBLIC_ENDPOINTS = Object.freeze({
    [C.PROJECTS_LIST]: '/sales/projects',
    [C.ORDER_CREATE]: '/sales/orders',
});
